<template>
    <div class="each-hotel">
        <div class="top-zone">
            <img :src="item.img" class="scene-img img-responsive" @error.once="__change__no__image">
            <div class="tags">
                <div
                    class="tag"
                    v-for="(tag,i) of item.tags"
                    :key="i"
                    v-text="tag"
                    v-show="tag!=''"
                ></div>
            </div>
            <div class="top-zone-footer"></div>
            <img v-if="item.isRecommend === 1"
                 class="recommend" 
                 :src="hotIconSrc"
                 alt="hot-icon">

        </div>
        <div class="footer-zone">
            <div class="title-text">
                <p v-text="item.name" class="title text-overflow"></p>
                <p class="address" v-if="item.detailAddress">
                    <span class="city" v-if="item.city" v-text="item.city"></span>
                    <img class="address-icon" :src="addressIcon">
                    <span class="detail-address" v-text="item.detailAddress"></span>
                </p>
                <div class="price" v-if="item.price || item.price === 0">
                    <div>
                        <span class="dolar">￥</span>
                        <span class="number" v-text="item.price"></span>
                        <span v-if="item.price != '暂无'" class="dolar">起</span>
                    </div>
                    <div>
                        <span class="star">{{item.score}}分&nbsp;&nbsp;</span>
                        <div class="divider"></div>
                        <span class="count">&nbsp;&nbsp;{{item.assess?item.assess:0}}</span>
                        <span class="count">条评论</span>
                    </div>
                </div>
                <!-- <p class="price" v-if="item.price || item.price === 0">
                    <span class="dolar">￥</span>
                    <span class="number" v-text="item.price"></span>
                    <span v-if="item.price != '暂无'" class="dolar">起</span>
                </p>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListOfHotel",
    // inheritAttrs: false,
    props: {
        item: Object
    },
    data() {
        return {
            addressIcon: "",
            hotIconSrc: ""
        };
    },
    computed: {
        tagsWithLevel() {
            let level = ["", "一", "二", "三", "四", "五", "六", "七"];
            if (this.item.tags) {
                return [level[this.item.level] + "星级", ...this.item.tags];
            } else {
                return [];
            }
        }
    },
    watch: {},
    created() {},
    mounted() {
        this.addressIcon = API.ossUrl + "scene/png/address-icon.png";
        this.hotIconSrc = API.ossUrl + "home/png/hot-icon.png";
    },
    destroyed() {},
    methods: {}
};
</script>


<style scoped lang="scss">
.each-hotel {
    padding: 0.266667rem 0 0.4rem;
    justify-content: space-between;
    &:nth-last-child(2) {
        border-bottom: 0;
    }
    .top-zone {
        margin: 0px;
        height: 4.48rem;
        border-radius: 0.266667rem;
        position: relative;
        .recommend {
            width: 1.44rem;
            height: 0.8rem;
            position: absolute;
            top: 0;
            left: 0;
            // display: table;
        }
        .scene-img {
            border-radius: 0.266667rem;
            height: 4.48rem;
        }
        .top-zone-footer {
            position: relative;
            top: -2.4rem;
            height: 1.12rem;
            background: linear-gradient(
                360deg,
                rgba(0, 0, 0, 1) 0%,
                rgba(0, 0, 0, 0) 100%
            );
            border-radius: 0 0 10px 10px;
        }
        .tags {
            position: relative;
            z-index: 10;
            top: -1.08rem;
            width: 100%;
            display: flex;
            flex-wrap: nowrap;
            margin-top: 0.293333rem;
            margin-bottom: 0.26rem;
            min-height: 0.746667rem;
            .tag {
                margin-left: 0.2133rem;
                padding: 0 0.266667rem;
                color: $white;
                background: rgba(0, 0, 0, 0.5);
                margin-bottom: 0.133333rem;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                flex: 0 0 auto;
                height: 0.56rem;
                border-radius: 0.16rem;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    .footer-zone {
        margin-top: 0.2667rem;
        width: 10rem;
        .title-text {
            .title {
                font-weight: bold;
                color: #444444;
                font-size: 0.48rem;
                font-family: PingFangSC-Medium;
                line-height: 0.6667rem;
            }
            .address {
                display: flex;
                width: 100%;
                margin: 0.2667rem 0 0.133333rem;
                align-items: flex-start;
                .city {
                    display: inline-block;
                    width: 1.0667rem;
                    line-height: 0.5333rem;
                    background: linear-gradient(
                        90deg,
                        rgba(255, 209, 2, 1) 0%,
                        rgba(247, 151, 29, 1) 100%
                    );
                    border-radius: 5px;
                    text-align: center;
                    color: $white;
                    font-size: 12px;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                }
                .address-icon {
                    margin-top: 0.026667rem;
                    height: 0.373333rem;
                }
                .detail-address {
                    font-size: 0.3733rem;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(140, 140, 140, 1);
                    line-height: 0.5333rem;
                    width: 7.733333rem;
                }
            }
            .price {
                font-size: 12px;
                color: #999;
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                padding-right: 1.0667rem;
                .dolar {
                    font-size: 0.3733rem;
                    font-family: PingFangSC-Medium;
                    color: #ff9200;
                    font-weight: bold;
                }
                .number {
                    font-size: 0.6933rem;
                    color: #ff9200;
                    font-family: PingFangSC-Semibold;
                    font-weight: bold;
                }
                .star {
                    font-size: 0.3733rem;
                    font-family: PingFangSC-Medium;
                    color: $orange;
                    font-weight: bold;
                }
                .divider {
                    display: inline-block;
                    width: 1px;
                    height: 0.2667rem;
                    background-color: #8c8c8c;
                    position: relative;
                }
                .count {
                    font-size: 0.3733rem;
                    color: #8c8c8c;
                    font-family: PingFangSC-Medium;
                }
            }
        }
        .address {
            color: #808080;
            font-size: 0.3733rem;
        }
    }
}
</style>

